<template>
<ItpPage
  :size="size"
  :header="documentTitle"
  :loaded="loaded"
  :noShow="!loaded"
  :modal="modal"
  itp-cname="SendMails"
  :modalBindings="b_7315092382398562_modalBindings"
  @close="evh_7315092382398562_close($event, {})"
>
  <UcHeader
    :card="!modal"
    :modal="modal"
    :title="documentTitle"
    slot="header"
    v-if="loaded"
    @close="evh_2248226175642056_close($event, {})"
  >
  </UcHeader>
  <UcBody
    :card="!modal"
    :modal="modal"
    v-if="loaded"
  >
    <ItpForm
      name="sendmail-options"
      id="zkhcfceubc"
      @submit="evh_1040167445267876_submit($event, {})"
    >
      <ItpFormGroup
        name="template"
        :label="'Template'|gettext"
        :description="'The template to use to generate the emails.'|gettext"
      >
        <ItpFormSelect
          name="name"
          size="md"
          v-model="selectedTemplate"
          required
          :options="templates"
          valueField="id"
          textField="name"
        >
        </ItpFormSelect>
      </ItpFormGroup>
    </ItpForm>
  </UcBody>
  <UcFooter
    :card="!modal"
    :modal="modal"
    slot="footer"
    v-if="loaded"
  >
    <ItpButton
      form="zkhcfceubc"
      :text="'Send'|gettext"
      type="submit"
      variant="primary"
      :spinning="actions.submit.isRunning"
    >
    </ItpButton>
    <ItpButton
      :text="'Cancel'|gettext"
      variant="default"
      :disabled="actions.submit.isRunning"
      @click.prevent.stop="evh_1419464017721962_clickPreventStop($event, {})"
    >
    </ItpButton>
  </UcFooter>
  <template
    slot="footer"
    v-if="loaded"
  >
  </template>
</ItpPage>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class SendMails extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "page",
  };

  beforeCreate() {
  }

  @Prop({
    required: true,
    default: null,
  })
  items!: list;

  @Watch('items')
  onItems(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("items")
  }

  @Prop({
    type: String,
    default: "sm",
  })
  size!: string;

  @Watch('size')
  onSize(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("size")
  }

  selectedTemplate!: any;
  templates!: any;

  async $$load_templates() {
    return this.$fn.fetch('list_template')
      .then(data => _.filter(data, { template_type: 'mjml' }))
  }

  ux!: any;
  b_7315092382398562_modalBindings!: any;
  dataMembers = ['selectedTemplate', 'templates', 'ux', 'b_7315092382398562_modalBindings'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        selectedTemplate: null,
        templates: null,
        ux: null,
        b_7315092382398562_modalBindings: {
          size: "sm",
        }
        ,
      },
    }
  }

  get document() {
    if (this.loaded) {

      return {
        title: this.$fn.gettext("Send emails"),
      }
    }
    return null;
  }

  async act_7315092382398562_closeModal_3176_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseModalActionArgs> {
    // parameterResolver name=act_7315092382398562_closeModal_3176, alias=undefined
    return {
      name: this.modalName,
      result: {
        close: true,
        cancel: true,
      }
      ,
    }
  }

  async evh_7315092382398562_close(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
  }

  async evh_2248226175642056_close(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_2248226175642056_close.executeFromDOM(this, event, scope);
  }

  async act_1040167445267876_register_3182_getActionArgs($event: actions.ActionEvent): Promise<actions.RegisterActionArgs> {
    // parameterResolver name=act_1040167445267876_register_3182, alias=undefined
    return {
      name: "resultLength",
      value: $event.data.response.data ? $event.data.response.data.length : 0,
    }
  }

  async act_1040167445267876_notification_3184_getActionArgs($event: actions.ActionEvent): Promise<actions.NotificationActionArgs> {
    // parameterResolver name=act_1040167445267876_notification_3184, alias=undefined
    return {
      message: this.$fn.ngettext("One email has been successfully enqueued.", "${n} emails have been successfully enqueued.", $event.data.resultLength),
    }
  }

  async act_1040167445267876_notification_3184_getWhen($event: actions.ActionEvent): Promise<actions.NotificationActionArgs> {
    // parameterResolver name=act_1040167445267876_notification_3184, alias=undefined
    return $event.data.resultLength > 0
  }

  async act_1040167445267876_reloadSlickgrid_3186_getActionArgs($event: actions.ActionEvent): Promise<actions.ReloadSlickgridActionArgs> {
    // parameterResolver name=act_1040167445267876_reloadSlickgrid_3186, alias=undefined
    return {
      grid: "all",
    }
  }

  async act_1040167445267876_closeComponent_3188_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseComponentActionArgs> {
    // parameterResolver name=act_1040167445267876_closeComponent_3188, alias=undefined
    return {
      result: {
        close: true,
      }
      ,
    }
  }

  async act_1040167445267876_request_3180_getActionArgs($event: actions.ActionEvent): Promise<actions.RequestActionArgs> {
    // parameterResolver name=act_1040167445267876_request_3180, alias=submit
    return {
      operation: "create_job",
      data: _.chain(this.items)
        .filter(item => item.customer_email)
        .map(item => ({
          job_type: 'sendmail:dunning_letter',
          job_data: {
            id: item.id,
            template: this.selectedTemplate,
            mail_to: item.customer_email
          }
        }))
        .value(),
    }
  }

  async evh_1040167445267876_submit(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_1040167445267876_submit.executeFromDOM(this, event, scope);
  }

  async evh_1419464017721962_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_1419464017721962_clickPreventStop.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_7315092382398562_closeModal_3176: actions.CloseModalAction;
    evh_7315092382398562_close_3175: actions.EventHandlerImpl;
    evh_7315092382398562_close: actions.EventHandlerGroup;
    act_2248226175642056_closeComponent_3178: actions.CloseComponentAction;
    evh_2248226175642056_close_3177: actions.EventHandlerImpl;
    evh_2248226175642056_close: actions.EventHandlerGroup;
    act_1040167445267876_register_3182: actions.RegisterAction;
    evh_1040167445267876_success_3181: actions.EventHandlerImpl;
    act_1040167445267876_notification_3184: actions.NotificationAction;
    evh_1040167445267876_success_3183: actions.EventHandlerImpl;
    act_1040167445267876_reloadSlickgrid_3186: actions.ReloadSlickgridAction;
    evh_1040167445267876_success_3185: actions.EventHandlerImpl;
    act_1040167445267876_closeComponent_3188: actions.CloseComponentAction;
    evh_1040167445267876_success_3187: actions.EventHandlerImpl;
    act_1040167445267876_request_3180: actions.RequestAction;
    evh_1040167445267876_submit_3179: actions.EventHandlerImpl;
    evh_1040167445267876_submit: actions.EventHandlerGroup;
    act_1419464017721962_closeComponent_3190: actions.CloseComponentAction;
    evh_1419464017721962_clickPreventStop_3189: actions.EventHandlerImpl;
    evh_1419464017721962_clickPreventStop: actions.EventHandlerGroup;
  }

  getActions() {
    const act_7315092382398562_closeModal_3176 = new actions.CloseModalAction(
      {
        actionArgs: this.act_7315092382398562_closeModal_3176_getActionArgs,
        events: [],
      }
    );
    const evh_7315092382398562_close_3175 = new actions.EventHandlerImpl(
      {
        action: act_7315092382398562_closeModal_3176,
        event: "close",
        displayName: "closeModal",
      }
    );
    const evh_7315092382398562_close = new actions.EventHandlerGroup(
      {
        handlers: [evh_7315092382398562_close_3175],
      }
    );
    const act_2248226175642056_closeComponent_3178 = new actions.CloseComponentAction(
      {
        events: [],
      }
    );
    const evh_2248226175642056_close_3177 = new actions.EventHandlerImpl(
      {
        action: act_2248226175642056_closeComponent_3178,
        event: "close",
        displayName: "closeComponent",
      }
    );
    const evh_2248226175642056_close = new actions.EventHandlerGroup(
      {
        handlers: [evh_2248226175642056_close_3177],
      }
    );
    const act_1040167445267876_register_3182 = new actions.RegisterAction(
      {
        actionArgs: this.act_1040167445267876_register_3182_getActionArgs,
        events: [],
      }
    );
    const evh_1040167445267876_success_3181 = new actions.EventHandlerImpl(
      {
        action: act_1040167445267876_register_3182,
        event: "success",
        displayName: "register",
      }
    );
    const act_1040167445267876_notification_3184 = new actions.NotificationAction(
      {
        actionArgs: this.act_1040167445267876_notification_3184_getActionArgs,
        when: this.act_1040167445267876_notification_3184_getWhen,
        events: [],
      }
    );
    const evh_1040167445267876_success_3183 = new actions.EventHandlerImpl(
      {
        action: act_1040167445267876_notification_3184,
        event: "success",
        displayName: "notification",
      }
    );
    const act_1040167445267876_reloadSlickgrid_3186 = new actions.ReloadSlickgridAction(
      {
        actionArgs: this.act_1040167445267876_reloadSlickgrid_3186_getActionArgs,
        events: [],
      }
    );
    const evh_1040167445267876_success_3185 = new actions.EventHandlerImpl(
      {
        action: act_1040167445267876_reloadSlickgrid_3186,
        event: "success",
        displayName: "reloadSlickgrid",
      }
    );
    const act_1040167445267876_closeComponent_3188 = new actions.CloseComponentAction(
      {
        actionArgs: this.act_1040167445267876_closeComponent_3188_getActionArgs,
        events: [],
      }
    );
    const evh_1040167445267876_success_3187 = new actions.EventHandlerImpl(
      {
        action: act_1040167445267876_closeComponent_3188,
        event: "success",
        displayName: "closeComponent",
      }
    );
    const act_1040167445267876_request_3180 = new actions.RequestAction(
      {
        actionArgs: this.act_1040167445267876_request_3180_getActionArgs,
        displayName: "submit",
        events: [evh_1040167445267876_success_3181, evh_1040167445267876_success_3183, evh_1040167445267876_success_3185, evh_1040167445267876_success_3187],
      }
    );
    const evh_1040167445267876_submit_3179 = new actions.EventHandlerImpl(
      {
        action: act_1040167445267876_request_3180,
        event: "submit",
        displayName: "submit",
      }
    );
    const evh_1040167445267876_submit = new actions.EventHandlerGroup(
      {
        handlers: [evh_1040167445267876_submit_3179],
      }
    );
    const act_1419464017721962_closeComponent_3190 = new actions.CloseComponentAction(
      {
        events: [],
      }
    );
    const evh_1419464017721962_clickPreventStop_3189 = new actions.EventHandlerImpl(
      {
        action: act_1419464017721962_closeComponent_3190,
        event: "click.prevent.stop",
        displayName: "closeComponent",
      }
    );
    const evh_1419464017721962_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_1419464017721962_clickPreventStop_3189],
      }
    );
    return {
      act_7315092382398562_closeModal_3176,
      evh_7315092382398562_close_3175,
      evh_7315092382398562_close,
      act_2248226175642056_closeComponent_3178,
      evh_2248226175642056_close_3177,
      evh_2248226175642056_close,
      act_1040167445267876_register_3182,
      evh_1040167445267876_success_3181,
      act_1040167445267876_notification_3184,
      evh_1040167445267876_success_3183,
      act_1040167445267876_reloadSlickgrid_3186,
      evh_1040167445267876_success_3185,
      act_1040167445267876_closeComponent_3188,
      evh_1040167445267876_success_3187,
      act_1040167445267876_request_3180,
      evh_1040167445267876_submit_3179,
      evh_1040167445267876_submit,
      act_1419464017721962_closeComponent_3190,
      evh_1419464017721962_clickPreventStop_3189,
      evh_1419464017721962_clickPreventStop,
      submit: act_1040167445267876_request_3180,
    }
  }
}

Vue.component("SendMails", SendMails);

</script>